import { render, staticRenderFns } from "./NoApps.vue?vue&type=template&id=9cf9f654"
import script from "./NoApps.vue?vue&type=script&lang=ts"
export * from "./NoApps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports